<template>
    <div >
            <div class="top-bar">
                <span @click="goBack">
                    <i class="left"></i>
                </span>
                <span class="heading_new">Report Components</span>
                <!-- <span class="spacer"/> -->
                <!-- <span class="refresh-icon">
                    <img src="@/assets/path-copy.svg">
                </span> -->
            </div>
       <div class="main-container">
         <tl-accordion :headerName="this.$route.query.id" :active="true">
          <template v-slot:accordionBody>
          </template>
         </tl-accordion>
         <tl-accordion headerName="Company Info">
          <template v-slot:accordionBody>
               <tl-checkbox
                  label="Select All"
                 @change="(bool)=>{Coheadcheckbox=bool}"
                 :checked="Coheadcheckbox"
                 />
                 <div class="twoColumnGrid space">
                    <div class="radiocontainer">
                     <tl-checkbox label="Employer contribution" :checked="Coheadcheckbox"/>
                      <div class="radio">
                          <tl-radio name="radio" label="Gross column" id="gross" value="gross" v-model="radio"/>
                          <tl-radio name="radio" label="Net Pay column"  id="pay" value="pay" v-model="radio"/>
                      </div>
                    </div>
                    <tl-checkbox label="FBP Components" :checked="Coheadcheckbox"/>
                    <tl-checkbox label="Standard CTC components" :checked="Coheadcheckbox"/>
                    <tl-checkbox label="LOP amount difference" :checked="Coheadcheckbox"/>
                    <div class="radiocontainer">
                      <tl-checkbox label="Unpaid CTC components" :checked="Coheadcheckbox"/>
                      <div class="radio">
                          <tl-radio name="radio2" label="Gross column" id="gross2" value="gross" v-model="radio2"/>
                          <tl-radio name="radio2" label="Net Pay column" id="pay2" value="pay" v-model="radio2"/>
                      </div>
                    </div>
                    <tl-checkbox label="EPS and EDLI" :checked="Coheadcheckbox"/>
                    <tl-checkbox label="Group by departments" :checked="Coheadcheckbox"/>
                    <tl-checkbox label="Allow columns with zero values" :checked="Coheadcheckbox"/>
                 </div>
          </template>
         </tl-accordion>
         <tl-accordion headerName="Employee Info">
          <template v-slot:accordionBody>
               <tl-checkbox
                  label="Select All"
                 @change="(bool)=>{Empheadcheckbox=bool}"
                 :checked="Empheadcheckbox"
                 />
               <div class="threeColumnGrid space">
                    <tl-checkbox label="Employee Name" :checked="Empheadcheckbox"/>
                    <tl-checkbox label="Employee Code" :checked="Empheadcheckbox"/>
                    <tl-checkbox label="Reporting Manager" :checked="Empheadcheckbox"/>
                    <tl-checkbox label="Passport No." :checked="Empheadcheckbox"/>
                    <tl-checkbox label="Gender" :checked="Empheadcheckbox"/>
                    <tl-checkbox label="Passport Expiry Date" :checked="Empheadcheckbox"/>
                 </div>
          </template>
         </tl-accordion>
       </div>
        <bottom-action-container >
            <template slot="end">
                <btn-grp>
                  <btn text="Cancel" type="secondary" @click="goBack"/>
                  <btn text="Save" type="primary" @click="goBack" />
                </btn-grp>
            </template>
          </bottom-action-container>
    </div>
</template>

<script>
export default {
  data(){
    return{
      Coheadcheckbox: true,
      Empheadcheckbox: true,
      radio:'gross',
      radio2:'gross'
    }
  },
  methods:{
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.space{
  padding-top:50px;
}
.radiocontainer{
    grid-row: span 3;
}
.radio{
    display: flex;
    padding: 20px 0px 10px 20px;
}
.footer-width{
  width: 90%;
}
</style>
